import React, { Fragment, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getDataDomainSubdomain } from "../../redux/accessManagement/accessManagement.action";

import AddNewMember from "./addNewMember";

import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";

import ChangeMemberRoleDialog from "./ChangeMemberRoleDialog.js";
import ChangeMemberRolePermissionDialog from "./ChangeMemberPermissonRoleDialog.js";
import { ChangeUserRoleMutation } from "../../mutations/AccessManagementMutationHook.js";

import { useToast } from "../../context/ToastContext.js";
import { FilterMatchMode } from "primereact/api";
import { MultiSelect } from "primereact/multiselect";
import usePermissionCheck from "../../hooks/PermissionCheck.js";
import UserManagement from "./UserManagement.js";

export const multiSelectFilter = (options, key, data) => {
  let optionitem = Array.from(new Set(data?.map(user => user[key])))
  return (
    <MultiSelect
      value={options.value}
      options={optionitem?.map(user => ({ label: user, value: user }))}
      itemTemplate={(option) => {
        return (
          <span>{option.label}</span>
        );
      }}
      onChange={(e) => options.filterApplyCallback(e.value)}
      optionLabel="label"
      placeholder="Any"
      className="p-column-filter"
      maxSelectedLabels={1}
      style={{ minWidth: '10rem' }}
    />
  );
};


function AccessManagement() {

  const { isAccessLoading, access } = usePermissionCheck()
  const toast = useToast();
  const dispatch = useDispatch();

  // State for managing various UI elements
  const [enableChangeMemberRolePopUp, setEnableChangeMemberRolePopUp] = useState(false);
  const [enableChangeMemberPermissionRolePopUp, setEnableChangeMemberPermissionRolePopUp] = useState(false);
  const [enableNewMemberPopUp, setEnableNewMemberPopUp] = useState(false);
  const [selectedDomainItems, setSelectedDomainItems] = useState([]);
  const [activeTab, setActiveTab] = useState(0); // 0 for "Members", 1 for "Data Assets"

  const [selectedRows, setSelectedRows] = useState(null);

  // Redux state selectors
  const { steppersData } = useSelector((state) => state.crumbs);
  const { apiData } = useSelector((state) => state.accessManagement);

  // Filters for searching members
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    user_name: { value: null, matchMode: FilterMatchMode.IN },
    user_email: { value: null, matchMode: FilterMatchMode.IN },
    data_asset_name: { value: null, matchMode: FilterMatchMode.IN },
  });

  const resetFilters = () => {
    setFilters({
      global: { value: '', matchMode: FilterMatchMode.CONTAINS },
      user_name: { value: null, matchMode: FilterMatchMode.IN },
      user_email: { value: null, matchMode: FilterMatchMode.IN },
      data_asset_name: { value: null, matchMode: FilterMatchMode.IN },
    });

  };
  // Handles changes in the search input
  const onGlobalFilterChange = (e) => { const value = e.target.value; let _filters = { ...filters }; _filters['global'].value = value; setFilters(_filters) };

  // Fetch domain-subdomain data when the component mounts
  useEffect(() => {
    dispatch(getDataDomainSubdomain());
  }, [dispatch]);

  // Memoized Panel Menu Data
  const panelMenuData = useMemo(
    () =>
      apiData?.domainSubDomain?.data?.map((domain) => ({
        label: domain.domain_name,
        key: `${domain.domain_name}:D`,
        icon: "pi pi-database",
        items: domain.subdomains.map((subdomain) => ({
          label: subdomain.sub_domain_name,
          icon: "pi pi-database",
          template: (
            <div
              className={`p-menuitem-link ${selectedDomainItems[`${subdomain.sub_domain_name}:SD`] ? "highlighted" : ""
                }`}
            >
              <span className={subdomain.icon}></span>
              {subdomain.sub_domain_name}
            </div>
          ),
          key: `${subdomain.sub_domain_name}:SD`,
        })),
      })),
    [apiData?.domainSubDomain?.data, selectedDomainItems]
  );

  // Function to remove selected members
  const { mutate: deleteUser, isPending: isDeleting } = ChangeUserRoleMutation(
    () => {
      toast({ severity: "info", summary: "Confirmed", detail: "User Deleted Successfully.", life: 3000 });
      resetFilters()
    },
    (error) => {
      toast({ severity: "info", summary: "Error", detail: error.response.data.detail, life: 3000 });
    }
  );

  const acceptRemoveMember = () => {
    deleteUser(
      selectedRows.map((item) => ({
        ...item,
        end_date: Date.now(),
        last_modified_by: localStorage.getItem("userId"),
      }))
    );
    setSelectedRows(null)
  };

  return (
    <div >
    <Fragment >
      <ConfirmDialog />

      {/* Change Role Popups */}
      {enableChangeMemberRolePopUp && <ChangeMemberRoleDialog userIds={selectedRows} onHide={() => setEnableChangeMemberRolePopUp(false)} />}
      {enableChangeMemberPermissionRolePopUp && <ChangeMemberRolePermissionDialog userIds={selectedRows} onHide={() => setEnableChangeMemberPermissionRolePopUp(false)} />}

      <UserManagement setEnableNewMemberPopUp={setEnableNewMemberPopUp} />
      {enableNewMemberPopUp && <AddNewMember onHide={() => setEnableNewMemberPopUp(false)} />}

    </Fragment>
    </div>
  );
}


export default AccessManagement;



